import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceCollaboratorsFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { collaborators: Array<(
    { __typename: 'Collaborator' }
    & Pick<Types.Collaborator, 'id' | 'fullName'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarUrl' | 'fullName' | 'initials'>
    )> }
  )> }
);

export const WorkspaceCollaboratorsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceCollaborators' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaborators' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nonPublic' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'initials' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceCollaboratorsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceCollaboratorsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceCollaboratorsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceCollaboratorsFragment>,
    'data'
  > {
  data?: WorkspaceCollaboratorsFragment;
}

export const useWorkspaceCollaboratorsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceCollaboratorsFragmentOptions): UseWorkspaceCollaboratorsFragmentResult => {
  const result = Apollo.useFragment<WorkspaceCollaboratorsFragment>({
    ...options,
    fragment: WorkspaceCollaboratorsFragmentDoc,
    fragmentName: 'WorkspaceCollaborators',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as WorkspaceCollaboratorsFragment };
};
